import AOS from 'aos'
import 'aos/dist/aos.css'

AOS.init({
  delay: 100,
//   offset: 200,
  mirror: false,
  duration: 400,
  once: true, 
  mirror: false, 
  anchorPlacement: 'top-bottom',
});
